module.exports = __webpack_public_path__ + "img/product-alert-icon.6d40acfc.svg";